<div class="dashboard-shell">
    <div class="dashboard-header">
        <div class="header-left">
            <button class="back-btn" (click)="goHome()" title="Back to Notification Agent">
                &larr;
            </button>
            <h1 class="dashboard-title">
                <img src="assets/images/Chevron_Logo 3.png" alt="Chevron" class="dashboard-logo" />
                Overview Dashboard
            </h1>
        </div>
        <div class="header-user" *ngIf="userName">
            <span class="user-name">{{ userName }}</span>
            <img *ngIf="showPhoto" class="user-photo" [src]="userPhoto" (error)="showPhoto = false" [alt]="userName"
                title="{{ userName }}" />
            <span *ngIf="!showPhoto" class="user-initials" [title]="userName">{{ userInitials }}</span>
        </div>
    </div>


    <!-- Primary tabs code -->
    <div class="main-tabs">
        <button class="main-tab" [class.active]="mainTab === 'overview'" (click)="setMainTab('overview')">
            Overview
        </button>
        <button class="main-tab" [class.active]="mainTab === 'analytics'" (click)="setMainTab('analytics')">
            Analytics
        </button>
    </div>

    <!-- Sub-selector: Overview -->
    <div class="view-selector" *ngIf="mainTab === 'overview'">
        <label class="view-label" for="overview-view">View</label>
        <select id="overview-view" class="view-dropdown" [ngModel]="overviewView"
            (ngModelChange)="setOverviewView($event)">
            <option value="requests">Requests</option>
            <option *ngIf="canApprove" value="approvals">Approvals</option>
        </select>
    </div>

    <!-- Sub-selector: Analytics -->
    <div class="view-selector" *ngIf="mainTab === 'analytics'">
        <label class="view-label" for="analytics-view">Analytics for</label>
        <select id="analytics-view" class="view-dropdown" [ngModel]="analyticsView"
            (ngModelChange)="setAnalyticsView($event)">
            <option value="requests">My Requests</option>
            <option *ngIf="canApprove" value="approvals">My Approvals</option>
        </select>
    </div>

    <!-- Requests tab -->
    <div class="tab-panel" *ngIf="mainTab === 'overview' && overviewView === 'requests'">
        <div class="panel-status" *ngIf="loadingRequests">Loading requests…</div>
        <div class="panel-error" *ngIf="requestsError">{{ requestsError }}</div>
        <div class="panel-status" *ngIf="!loadingRequests && !requestsError && requests.length === 0">
            You have not submitted any campaigns yet.
        </div>

        <div class="table-wrap" *ngIf="!loadingRequests && requests.length > 0">
            <table class="data-table">
                <thead>
                    <tr>
                        <th class="expand-col"></th>
                        <th>Campaign Name</th>
                        <th class="campaign-id-col">CampaignID</th>
                        <th>Version</th>
                        <th>Status</th>
                        <th>Submitted</th>
                        <th>Approver</th>
                        <th>Audience</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let row of requests">
                        <tr class="clickable" (click)="toggleDetails(row)">
                            <td class="expand-col">
                                <span class="chevron" [class.open]="isExpanded(row)">&rsaquo;</span>
                            </td>
                            <td class="strong">{{ row.campaign_name || '—' }}</td>
                            <td class="campaign-id-col">{{ row.campaign_alias || '—' }}</td>
                            <td>{{ row.version }}</td>
                            <td><span [class]="statusClass(row.status)">{{ row.status }}</span></td>
                            <td>{{ row.submitted_at | date: 'medium' }}</td>
                            <td>{{ row.approver || '—' }}</td>
                            <td class="muted">{{ audienceSummary(row.audience) }}</td>
                        </tr>
                        <tr class="detail-row" *ngIf="isExpanded(row)">
                            <td colspan="8">
                                <div class="detail-grid">
                                    <div class="detail-item full reminder-timetable" *ngIf="isApproved(row.status)">
                                        <button type="button" class="reminder-toggle"
                                            (click)="toggleReminderDetails(row)"
                                            [attr.aria-expanded]="areRemindersExpanded(row)">
                                            <span class="chevron"
                                                [class.open]="areRemindersExpanded(row)">&rsaquo;</span>
                                            <span>Send Out Schedule</span>
                                        </button>
                                        <table class="reminder-table"
                                            *ngIf="areRemindersExpanded(row) && row.reminders.length">
                                            <thead>
                                                <tr>
                                                    <th>Reminder</th>
                                                    <th>Status</th>
                                                    <th>Scheduled Send out Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let reminder of row.reminders">
                                                    <td>{{ reminderLabel(reminder.reminder_number) }}</td>
                                                    <td>{{ reminder.sent_status || '—' }}</td>
                                                    <td>{{ reminder.scheduled_at ? (reminder.scheduled_at | date:
                                                        'medium') : '—' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="reminder-empty"
                                            *ngIf="areRemindersExpanded(row) && !row.reminders.length">
                                            No reminders scheduled.
                                        </div>
                                    </div>
                                    <div class="detail-item full">
                                        <span class="detail-label">Audience Message</span>
                                        <span class="detail-value">{{ row.audience_message || '—' }}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="detail-label">Priority</span>
                                        <span class="detail-value">{{ row.details.priority || '—' }}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="detail-label">Channel</span>
                                        <span class="detail-value">{{ row.details.channel || '—' }}</span>
                                    </div>
                                    <div class="detail-item full">
                                        <span class="detail-label">Audience</span>
                                        <span class="detail-value">{{ audienceSummary(row.details.audience) }}</span>
                                    </div>
                                    <div class="detail-item full">
                                        <span class="detail-label">Background</span>
                                        <span class="detail-value">{{ row.details.background || '—' }}</span>
                                    </div>
                                    <div class="detail-item full">
                                        <span class="detail-label">Business Goal</span>
                                        <span class="detail-value">{{ row.details.business_goal || '—' }}</span>
                                    </div>
                                    <div class="detail-item full">
                                        <span class="detail-label">Communications Outcome</span>
                                        <span class="detail-value">{{ row.details.communications_outcome || '—'
                                            }}</span>
                                    </div>
                                    <div class="detail-item full">
                                        <span class="detail-label">Key Messages</span>
                                        <span class="detail-value">{{ row.details.key_messages || '—' }}</span>
                                    </div>
                                    <div class="detail-item full">
                                        <span class="detail-label">Tactics</span>
                                        <span class="detail-value">{{ row.details.tactics || '—' }}</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>


    <!-- Approvals tab -->
    <div class="tab-panel" *ngIf="mainTab === 'overview' && overviewView === 'approvals' && canApprove">
        <div class="panel-status" *ngIf="loadingApprovals">Loading approvals…</div>
        <div class="panel-error" *ngIf="approvalsError">{{ approvalsError }}</div>
        <div class="panel-status" *ngIf="!loadingApprovals && !approvalsError && approvals.length === 0">
            There are no campaigns assigned to you for approval.
        </div>

        <div class="table-wrap" *ngIf="!loadingApprovals && approvals.length > 0">
            <table class="data-table">
                <thead>
                    <tr>
                        <th class="expand-col"></th>
                        <th>Campaign Name</th>
                        <th class="campaign-id-col">CampaignID</th>
                        <th>Version</th>
                        <th>Status</th>
                        <th>Requestor</th>
                        <th>Approver</th>
                        <th>Submitted</th>
                        <th>Action Time</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let row of approvals">
                        <tr class="clickable" (click)="toggleDetails(row)">
                            <td class="expand-col">
                                <span class="chevron" [class.open]="isExpanded(row)">&rsaquo;</span>
                            </td>
                            <td class="strong">{{ row.campaign_name || '—' }}</td>
                            <td class="campaign-id-col">{{ row.campaign_alias || '—' }}</td>
                            <td>{{ row.version }}</td>
                            <td><span [class]="statusClass(row.status)">{{ approvalStatusLabel(row.status) }}</span>
                            </td>
                            <td>{{ row.requestor || '—' }}</td>
                            <td>{{ row.approver || '—' }}</td>
                            <td>{{ row.created_at | date: 'medium' }}</td>
                            <td>{{ row.action_at | date: 'medium' }}</td>
                        </tr>
                        <tr class="detail-row" *ngIf="isExpanded(row)">
                            <td colspan="9">
                                <div class="detail-grid">
                                    <div class="detail-item full reminder-timetable" *ngIf="isApproved(row.status)">
                                        <button type="button" class="reminder-toggle"
                                            (click)="toggleReminderDetails(row)"
                                            [attr.aria-expanded]="areRemindersExpanded(row)">
                                            <span class="chevron"
                                                [class.open]="areRemindersExpanded(row)">&rsaquo;</span>
                                            <span>Send Out Schedule</span>
                                        </button>
                                        <table class="reminder-table"
                                            *ngIf="areRemindersExpanded(row) && row.reminders.length">
                                            <thead>
                                                <tr>
                                                    <th>Reminder</th>
                                                    <th>Status</th>
                                                    <th>Scheduled Send out Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let reminder of row.reminders">
                                                    <td>{{ reminderLabel(reminder.reminder_number) }}</td>
                                                    <td>{{ reminder.sent_status || '—' }}</td>
                                                    <td>{{ reminder.scheduled_at ? (reminder.scheduled_at | date:
                                                        'medium') : '—' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="reminder-empty"
                                            *ngIf="areRemindersExpanded(row) && !row.reminders.length">
                                            No reminders scheduled.
                                        </div>
                                    </div>
                                    <div class="detail-item full">
                                        <span class="detail-label">Audience Message</span>
                                        <span class="detail-value">{{ row.audience_message || '—' }}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="detail-label">Approved / Rejected By</span>
                                        <span class="detail-value">{{ row.approved_by || '—' }}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="detail-label">Priority</span>
                                        <span class="detail-value">{{ row.details.priority || '—' }}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="detail-label">Channel</span>
                                        <span class="detail-value">{{ row.details.channel || '—' }}</span>
                                    </div>
                                    <div class="detail-item full">
                                        <span class="detail-label">Audience</span>
                                        <span class="detail-value">{{ audienceSummary(row.details.audience) }}</span>
                                    </div>
                                    <div class="detail-item full">
                                        <span class="detail-label">Background</span>
                                        <span class="detail-value">{{ row.details.background || '—' }}</span>
                                    </div>
                                    <div class="detail-item full">
                                        <span class="detail-label">Business Goal</span>
                                        <span class="detail-value">{{ row.details.business_goal || '—' }}</span>
                                    </div>
                                    <div class="detail-item full">
                                        <span class="detail-label">Communications Outcome</span>
                                        <span class="detail-value">{{ row.details.communications_outcome || '—'
                                            }}</span>
                                    </div>
                                    <div class="detail-item full">
                                        <span class="detail-label">Key Messages</span>
                                        <span class="detail-value">{{ row.details.key_messages || '—' }}</span>
                                    </div>
                                    <div class="detail-item full">
                                        <span class="detail-label">Tactics</span>
                                        <span class="detail-value">{{ row.details.tactics || '—' }}</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Analytics: My Requests (requestor) -->
    <div class="tab-panel" *ngIf="mainTab === 'analytics' && analyticsView === 'requests'">
        <div class="analytics-intro">
            <span class="analytics-eyebrow">Analytics · Requestor</span>
            <h2 class="analytics-heading">My Campaigns</h2>
            <p class="analytics-sub">Insights across the campaigns you have submitted.</p>
        </div>

        <div class="panel-status" *ngIf="analyticsLoading">Loading analytics…</div>
        <div class="panel-error" *ngIf="analyticsError">{{ analyticsError }}</div>

        <ng-container *ngIf="!analyticsLoading">
            <div class="kpi-grid">
                <div class="kpi-card">
                    <span class="kpi-label">Total Campaigns</span>
                    <span class="kpi-value">{{ totalCampaigns }}</span>
                    <span class="kpi-hint">Latest version of each campaign</span>
                </div>
                <div class="kpi-card">
                    <span class="kpi-label">Avg. Audience Size</span>
                    <span class="kpi-value">{{ avgAudienceSize }}</span>
                    <span class="kpi-hint">Recipients per campaign</span>
                </div>
                <div class="kpi-card">
                    <span class="kpi-label">Total Recipients</span>
                    <span class="kpi-value">{{ totalRecipients }}</span>
                    <span class="kpi-hint">Across all campaigns</span>
                </div>
                <div class="kpi-card">
                    <span class="kpi-label">Scheduled</span>
                    <span class="kpi-value">{{ scheduledCount }}</span>
                    <span class="kpi-hint">Approved & set for a future date</span>
                </div>
            </div>

            <div class="chart-grid">
                <div class="chart-card">
                    <h3 class="chart-title">Campaign Status</h3>
                    <p class="chart-sub">Submitted, approved, rejected, canceled, completed and abandoned campaigns.</p>
                    <div class="chart-canvas-wrap">
                        <canvas #statusCanvas></canvas>
                    </div>
                </div>

                <div class="chart-card">
                    <h3 class="chart-title">Active vs Scheduled</h3>
                    <p class="chart-sub">Approved campaigns live now vs scheduled for later.</p>
                    <div class="chart-canvas-wrap">
                        <canvas #scheduleCanvas></canvas>
                    </div>
                </div>

                <div class="chart-card">
                    <h3 class="chart-title">Recipients by Campaign</h3>
                    <p class="chart-sub">Audience target size for the top campaigns.</p>
                    <div class="chart-canvas-wrap">
                        <canvas #recipientsCanvas></canvas>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- Analytics: My Approvals (approver) -->
    <div class="tab-panel" *ngIf="mainTab === 'analytics' && analyticsView === 'approvals' && canApprove">
        <div class="analytics-intro">
            <span class="analytics-eyebrow">Analytics · Approver</span>
            <h2 class="analytics-heading">My Approvals</h2>
            <p class="analytics-sub">Insights across the campaigns assigned to you for approval.</p>
        </div>

        <div class="panel-status" *ngIf="analyticsLoading">Loading analytics…</div>
        <div class="panel-error" *ngIf="analyticsError">{{ analyticsError }}</div>

        <ng-container *ngIf="!analyticsLoading">
            <div class="kpi-grid">
                <div class="kpi-card">
                    <span class="kpi-label">Assigned Campaigns</span>
                    <span class="kpi-value">{{ totalAssigned }}</span>
                    <span class="kpi-hint">Unique campaigns in your queue</span>
                </div>
                <div class="kpi-card">
                    <span class="kpi-label">Approved To Date</span>
                    <span class="kpi-value">{{ approvedToDate }}</span>
                    <span class="kpi-hint">Total campaigns you've approved</span>
                </div>
                <div class="kpi-card">
                    <span class="kpi-label">Avg. Response Time</span>
                    <span class="kpi-value">{{ avgResponseHours | number: '1.0-1' }}<span
                            class="kpi-unit">h</span></span>
                    <span class="kpi-hint">From submission to your decision</span>
                </div>
                <div class="kpi-card">
                    <span class="kpi-label">Awaiting Approval</span>
                    <span class="kpi-value">{{ apprPendingCount }}</span>
                    <span class="kpi-hint">Awaiting your decision</span>
                </div>
            </div>

            <div class="chart-grid">
                <div class="chart-card">
                    <h3 class="chart-title">Approval Outcomes</h3>
                    <p class="chart-sub">Approved, rejected, canceled, completed, abandoned and awaiting-approval
                        decisions.
                    </p>
                    <div class="chart-canvas-wrap">
                        <canvas #outcomeCanvas></canvas>
                    </div>
                </div>

                <div class="chart-card">
                    <h3 class="chart-title">Approval Response Time</h3>
                    <p class="chart-sub">How quickly you acted on submissions.</p>
                    <div class="chart-canvas-wrap">
                        <canvas #responseCanvas></canvas>
                    </div>
                </div>

                <div class="chart-card">
                    <h3 class="chart-title">Approved To Date</h3>
                    <p class="chart-sub">Cumulative approvals over time.</p>
                    <div class="chart-canvas-wrap">
                        <canvas #trendCanvas></canvas>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>